import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { IconButton } from "@mui/material";
import { BOX_SHADOWS } from "../../Shared/styles";

export const ElevationStyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    marginLeft: "0px !important",
    flex: 1,
    width: "inherit",
    "& .MuiInputBase-input": {
        padding: theme.spacing(0, 1, 0, 0),
        paddingLeft: "16px",
        paddingRight: "48px",
        marginLeft: 0,
        width: "100%",
        color: "var(--community-color-primary-text)",
        borderRadius: "8px",
        fontSize: "14px",
        height: "48px",
        transition: "box-shadow 0.3s ease-in-out",
        ...BOX_SHADOWS.ELEVATION_3,
        "&:hover": {
            ...BOX_SHADOWS.ELEVATION_3,
        },
    },
    "& .MuiInputBase-input::placeholder": {
        color: "var(--community-color-secondary-text)",
        fontSize: "14px",
    },
    "@media (min-width: 640px)": {
        "& .MuiInputBase-input": {
            ...BOX_SHADOWS.ELEVATION_0,
        },
    },
}));

export const OverlayStyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    marginLeft: "0px !important",
    flex: 1,
    height: "40px",
    width: "inherit",
    backgroundColor: "var(--community-color-transparent-black-05)",
    borderRadius: "8px",
    padding: "12px",
    "@media(min-width:640px)": {
        height: "48px",
        padding: "12px 16px",
    },
    "& .MuiInputBase-input": {
        padding: theme.spacing(0, 1, 0, 0),
        paddingLeft: "12px",
        paddingRight: "40px",
        marginLeft: 0,
        transition: theme.transitions.create("width"),
        width: "100%",
        color: "var(--community-color-secondary-text)",
        borderRadius: "8px",
        fontSize: "14px",
        "@media(min-width:640px)": {
            fontSize: "16px",
            height: "48px",
        },
        height: "40px",
    },
    "& .MuiInputBase-input::placeholder": {
        color: "var(--community-placeholder-color)",
        fontSize: "14px",
        "@media(min-width:640px)": {
            fontSize: "16px",
        },
    },
}));

export const Search = styled("div")({
    position: "relative",
    borderRadius: "8px",
    marginRight: "0",
    backgroundColor: "var(--community-color-transparent-white-90)",
    display: "flex",
    alignItems: "center",
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 1)",
    },
    marginLeft: 0,
    width: "100%",
    height: "100%",
});

export const IconButtonClear = styled(IconButton)({
    position: "absolute",
    right: 0,
});
